import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import ArrowIcon from "../../assets/images/article-link-card-arrow-icon.png";
import BriefcaseIcon from "../../assets/images/article-link-card-briefcase-icon.png";
import { fetchContentCollection } from "../../behavior/api/content";
import { PageRoute } from "../../constants";
import { Heading, HorizontalLine, Image } from "../elements";

const ArticleLinkCard = () => {
    const { data: contentCollection, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { tags: ["Dashboard Interview Guide"], limit: 1 }],
        queryFn: fetchContentCollection({
            tags: ["Dashboard Interview Guide"],
            optionalTags: [],
            page: 1,
            limit: 1,
        }),
    });

    const hasContent = !loading && contentCollection?.contents && contentCollection.contents.length > 0;
    const article = hasContent ? contentCollection.contents[0] : undefined;

    return (
        <Link
            className="article-link-card-wrapper"
            to={article ? `${PageRoute.LEARN_WITH_HUBERT_ARTICLE}/${article.id}` : PageRoute.LEARN_WITH_HUBERT}
        >
            <div className="head-section">
                <Image src={BriefcaseIcon} alt="Briefcase icon" className="briefcase-icon" />
                {article && <Heading level="h4">{article.primaryTag}</Heading>}
            </div>
            <HorizontalLine weight="semi-dark" className="mb-6" />
            <div className="body-section">
                {article && <Heading level="h4">{article.title}</Heading>}
                <div className="arrow-icon-wrapper">
                    <Image src={ArrowIcon} alt="Arrow icon" className="arrow-icon" />
                </div>
            </div>
        </Link>
    );
};

export default ArticleLinkCard;
